import cx from "classnames";
import React from "react";
import { Photo } from "component-library";
import { dataTestIds } from "data-testids";
import { Check1Icon } from "assets";

import { IPhoto } from "models/api";

import { getImageUrl, ImageLocation } from "services/urlBuilder";

import "./PhotoGallery.scss";

export interface IPhotoGalleryProps {
  photos: IPhoto[];
  onSelect?: (photo: IPhoto) => void;
  selectedPhotoId: string;
}

export class PhotoGallery extends React.PureComponent<IPhotoGalleryProps> {
  public render() {
    const { photos, selectedPhotoId } = this.props;

    return (
      <div className="c-photo-gallery">
        {photos.map((photo) => (
          <div
            key={photo.id}
            className={cx("c-photo-gallery__photo", {
              "c-photo-gallery__photo--selected": selectedPhotoId === photo.id,
            })}
            role="button"
            tabIndex={0}
            onClick={this.onSelect(photo)}
            data-testid={`${dataTestIds.nuJobsApp["BreakdownDetails.SuggestionsSection.photo"]}`}
          >
            {selectedPhotoId === photo.id && <Check1Icon />}
            <Photo
              className="c-photo-gallery__image"
              src={getImageUrl(photo.fileName, ImageLocation.GalleryPhoto)}
              hasLoadingSpinner={true}
            />
          </div>
        ))}
      </div>
    );
  }

  private onSelect = (photo: IPhoto) => () => {
    this.props.onSelect?.(photo);
  };
}
